export const customColor = [
    {
        id:'3E1293',
        title: 'Morado',
        colors: {
            default: '#3E1293',
            primary: '#5A56BF',
            secondary: '#7D7AD1',
        }
    },
    {
        id:'678B6A',
        title: 'Verde',
        colors: {
            default: '#678B6A',
            primary: '#9BBF9D',
            secondary: '#CED9B8',
        }
    },
    {
        id:'2F8383',
        title: 'Aqua',
        colors: {
            default: '#2F8383',
            primary: '#35A5A5',
            secondary: '#83BEBE',
        }
    },
    {
        id:'C95F73',
        title: 'Rosa',
        colors: {
            default: '#C95F73',
            primary: '#F27289',
            secondary: '#F27289',
        }
    },
    {
        id:'E2914B',
        title: 'Naranja',
        colors: {
            default: '#E2914B',
            primary: '#F27405',
            secondary: '#F27405',
        }
    },
    {
        id:'616469',
        title: 'Gris',
        colors: {
            default: '#616469',
            primary: '#3C4148',
            secondary: '#646B74',
        }
    }
];